import { MediaDeviceFailure } from "livekit-client";

export const ru = {
  createMeeting: "Создать видеовстречу",
  createdMeeting: {
    once: "Видеозвонок",
    permanent: "Повторяющийся видеозвонок"
  },
  loadingDemonstrate: "Пользователь начал демонстрацию, загрузка...",
  loadingJoin: "Загрузка видеозвонка...",
  runMeeting: "Запустить",
  required: "Поле обязательно для заполнения",
  youconnect: "Вы подключаетесь к видеозвонку",
  youname: "Ваше имя и компания",
  goconnect: "Подключиться",
  waitLeaderStart: "Дождитесь, когда организатор начнет видеозвонок",
  waitApprove: "Дождитесь, когда организатор примет ваш запрос",
  voiceon: "Включить микрофон",
  voiceoff: "Отключить микрофон",
  cameraon: "Включить камеру",
  on: "Включить",
  cameraoff: "Отключить камеру",
  settings: "Настройки",
  detail: "Детали встречи",
  more: "Eще",
  waitconnection: "Ожидание подключения",
  micro: "Микрофон",
  sound: "Звук",
  webcam: "Web-камера",
  muted: "Вам отключили микрофон",
  startrecord: "Начать запись видеозвонка",
  speakOnMicroOff: "Вас не слышно, включите микрофон",
  recording: "Включена запись",
  recording_tarif: "Запись доступна при наличии тарифа",
  endrecord: "Закончить запись экрана",
  empty: "Отсутствует",
  usersettings: "Управление участниками",
  userlist: "Участники",
  startdemonstarte: "Начать демонстрацию экрана",
  enddemonstarate: "Завершить демонстрацию экрана",
  alreadydemonstrate: "Демонстрация уже идет",
  leave: "Отключиться",
  endmeet: "Завершить видеовстречу",
  newmeet: "Новый видеозвонок",
  name: "Название",
  passname: "Укажите название видеозвонка",
  description: "Описание",
  passdescription: "Добавьте описание видеозвонка",
  create: "Создать",
  copymeet: "Копировать ссылку",
  showSpeakerInShare: "Показывать говорящего",
  hideSpeakerInShare: "Не показывать говорящего",
  copied: "Ссылка скопирована",
  linkcopied: "Ссылка скопирована",
  linkcopy: "Скопировать ссылку",
  downloadRecord: "Скачать запись",
  downloadRecordSummary: "Скачать резюме",
  downloadRecordSummaryLoading: "Создание резюме...",
  apply: "Сохранить",
  cancel: "Отменить",
  link: "Ссылка для подключения:",
  invite: "Чтобы пригласить других участников, отправьте им приглашение на видеозвонок",
  speak: "говорит…",
  speaks: "говорят…",
  and: "и еще",
  leader: "Организатор",
  kick: "Исключить из звонка",
  uoffcam: "отключил камеру",
  uoffmicro: "отключил микрофон",
  youstartdemo: "Вы начали демонстрацию экрана",
  ustartrecord: "Включена запись",
  roomrecords: "Видеозвонок записывается",
  uwaitrecord: "Ожидайте начала записи",
  uerrorrecord: "Неудалось начать запись, попробуйте позднее",
  uendrecord: "Запись остановлена",
  less5min: "Осталось менее 5 минут",
  roomCreateLoading:"Создание комнаты...",
  alreadyInRoom: {
    title: "Вы состоите в другой встрече",
    text: "Вы уверены, что хотите выйти из другой активной встречи, чтобы подключиться к этой?"
  },
  endCallModal: {
    title: "Выйти из видеозвонка?",
    text: "Вы уверены, что хотите выйти из видеозвонка? Вы можете выйти из видеозвонка или завершить его для всех участников.",
    back: "Назад",
    leave: "Выйти",
    end:"Завершить для всех"
  },
  modalControls: {
    back: "НАЗАД",
    start: "ЗАПУСТИТЬ",
    connect: "ПОДКЛЮЧИТЬСЯ",
    end: "ЗАВЕРШИТЬ"
  },
  endPage: {
    complete: "Видеозвонок завершен",
    leave: "Вы отключились от видеозвонка",
    "new-auth": "Соединение прервано",
    newAuthExitDescription: "В этом браузере был открыт другой видеозвонок.",
    kick: "Вы были исключены из видеозвонка",
    kickedDescription: "Вы были исключены организатором видеозвонка",
    network: "Соединение прервано",
    networkError: "Возникла проблема с интернет-соединением, проверьте подключение и обновите страницу.",
    "first-connect": "Соединение прервано",
    firstConnectDescription: "Возникла проблема с интернет-соединением, проверьте подключение и обновите страницу.",
    rejected: "Вы были отклонены организатором",
    rejectedDescription: "Запрос на подключение был отклонён организатором",
    tarifftime: "Видеозвонок завершен",
    expired: "Ссылка не действительна",
    expiredDescription: "Время жизни ссылки истекло, но вы можете создать новую",
    backBtn: "Вернуться"
  },
  tarifAllert: "На вашем тарифе видеозвонок ограничен до 15 мин. Для повышения тарифа Коннект оставьте заявку",
  target: "здесь",
  nextPage: "Следующая страница",
  prevPage: "Предыдущая страница",
  allOffMicro: "Отключить всем микрофоны",
  cameraMobileToggle: "Сменить камеру",
  changeMode: "Сменить режим просмотра",
  recordLinksTitle: "Запись доступна для скачивания:",
  recordLinksLoading: "Дождитесь, когда сформируется запись видеозвонка",
  record7days: "Запись доступна для скачивания в течение 30 дней.",
  validators: {
    fieldnames: {
      meetname: "Название",
      description: "Описание",
      name: "Поле"
    },
    messages: {
      empty: "не может быть пустым",
      maxLen: "должно быть короче",
      symbols: "символов"
    }
  },
  tarifStartCallModal: {
    title: "Тарифное ограничение",
    text: "Вы можете запускать видеозвонок не более одного раза в час. Для повышения тарифа Коннект обратитесь в обслуживающую вас компанию.",
    close: "Понятно"
  },
  tarifDisabledStartCallModal: {
    title: "Непредвиденная ошибка",
    text: "Произошла непредвиденная ошибка. Попробуйте позднее.",
    close: "Понятно"
  },
  endCallTarif: {
    free: "На тарифе организатора видеозвонок ограничен до 15 мин. Для повышения тарифа Коннект, организатор видеозвонка может обратиться в обслуживающую компанию.",
    pay: "На тарифе организатора видеозвонок ограничен до 6 часов. Для повышения тарифа Коннект, организатор видеозвонка может обратиться в обслуживающую компанию.",
    disabled: "Произошла непредвиденная ошибка. Звонок завершен."
  },
  deviceErrors: {
    common: "Не удалось определить устройство, проверьте настройки или разрешения в браузере.",
    micro: {
      [MediaDeviceFailure.NotFound]: "Отсутствует",
      [MediaDeviceFailure.Other]: "Ошибка",
      [MediaDeviceFailure.DeviceInUse]: "Устройство используется",
      [MediaDeviceFailure.PermissionDenied]: "Нехватает разрешений",
    },
    camera: {
      [MediaDeviceFailure.NotFound]: "Отсутствует",
      [MediaDeviceFailure.Other]: "Ошибка",
      [MediaDeviceFailure.DeviceInUse]: "Устройство используется",
      [MediaDeviceFailure.PermissionDenied]: "Нехватает разрешений",
    }
  },
  chat: {
    open: "Показать чат",
    close: "Скрыть чат",
    title: "Чат",
    placeholder: "Написать сообщение",
    drop: "Перетащите сюда файлы для отправки",
    emptyMessages: "Напишите сообщение или отправьте файл",
    emptyHistory: "История пуста",
    newMessagesSeparator: "НОВЫЕ СООБЩЕНИЯ",
    today: "Сегодня",
    errorGetStartMessages: "Ошибка загрузки чата",
    denied: "Доступ запрещен",
    chatHistoryLink: "Чат видеозвонка:",
    showChatHistory: "Просмотреть чат видеозвонка",
    clearChatTitle: "Очистить чат?",
    clearChatTooltip: "Очистить чат",
    clearChatDescr: "Вы уверены, что хотите очистить чат? Все сообщения и файлы будут удалены из истории чата.",
    clearBtn: "Очистить",
    clear: "Очистить чат"
  },
  monthsOf: {
    0: "Января",
    1: "Февраля",  
    2: "Марта",  
    3: "Апреля",  
    4: "Мая",  
    5: "Июня",  
    6: "Июля",  
    7: "Августа",  
    8: "Сентября",  
    9: "Октября",  
    10: "Ноября",  
    11: "Декабря"
  },
  tooltips: {
    handup: "Поднять руку",
    handdown: "Опустить руку",
    enterFullscreen: "Перейти в полноэкранный режим",
    exitFullscreen: "Выйти из полноэкранного режима",
  },
  sizeLimitModal: {
    title: "Файл слишком большого размера.",
    text: "На загрузку файлов действует ограничение в 100 Мб.",
  },
  modalButtons: {
    ok: "ПОНЯТНО",
    back: "НАЗАД"
  },
  chatRecordBlock: {
    title: "Чат и запись видеозвонка",
    loadingText: "Формируется запись и чат видеозвонка..."
  },
  youShared: "Вы демонстрируете экран",
  stopShare: "Остановить демонстрацию",
  permanentLinkSwitchText: "Постоянная ссылка на видеозвонок",
  WaitRoomSwitchText: "Подключение участников через комнату ожидания",
  backgroundEffects: "Фоновое изображение и эффекты",
  backgroundEffectWeak: "Слабое размытие",
  backgroundEffectStrong: "Сильное размытие",
  backgroundImageLimitModal: {
    title: "Фоновое изображение не добавлено",
    text: "Выберите файл с расширением JPEG, PNG, TIFF или WEBP размером не более 10 МБ",
  },
  noiseSuppression: "Шумоподавление микрофона",
  microLevel: "Уровень сигнала микрофона",
  linkNames: {
    chat: "Чат видеозвонка",
    record: "Запись видеозвонка",
    summary: "Резюме видеозвонка"
  },
  usersLabel: "В видеозвонке: ",
  waitRoom: {
    notification: {
      text: "Участники в комнате ожидания",
      button: "Показать"
    },
    label: "Комната ожидания: ",
    rejectAll: "Отклонить всех",
    approveAll: "Принять всех"
  },
  handUp: {
    notification: {
      one: "поднял руку",
      more: "подняли руку"
    }
  },
  moreList: {
    showChat: "Показать чат",
    hideChat: "Скрыть чат",
  },
  userControls: {
    adminAssignee: "Назначить организатором",
    adminRevoke: "Забрать права организатора",
    handDown: "Опустить руку",
    demoOff: "Отключить демонстрацию экрана",
    toWait: "Отправить в комнату ожидания"
  },
  summaryPage: {
    loading: "Формируется резюме видеозвонка",
    title: "Резюме видеозвонка",
    notFound: "Резюме не найдено"
  },
  deviceAuto: "По умолчанию",
  deviceLost: "Отсутствует",
} as const
